module.exports = __webpack_public_path__ + "img/card-offer-bell-pepper.44bbc2b0.png";